<template>
  <v-row class="mb-2">
    <v-col class="pt-0 px-0">
      <v-row>
        <v-col class="px-0 checklist-index-scroll">
          <div>
            <v-row>
              <v-col class="px-2">
                <v-expansion-panels
                  v-model="localExpandedPanels"
                  accordion
                  class="checklist-index-panels"
                  flat
                  multiple
                >
                  <v-expansion-panel
                    v-for="(section, index) in sections"
                    :key="section.key"
                    :class="{
                      'section-disabled': section.isDisabled,
                      'section-collapsed': section.isCompleted
                    }"
                  >
                    <v-expansion-panel-header
                      :class="{
                        'section-header-disabled': section.isDisabled,
                        'section-header-completed': section.isCompleted && !section.isDisabled,
                        'section-header-error': sectionHasValueChanges(section)
                      }"
                      class="py-0"
                    >
                      <div class="d-flex align-center justify-space-between w-100">
                        <div class="d-flex align-center">
                          <v-icon
                            :color="getSectionIconColor(section)"
                            class="mr-3"
                          >
                            {{ getSectionIcon(section) }}
                          </v-icon>
                          <span
                            :class="{
                              'section-title-disabled': section.isDisabled,
                              'section-title': !section.isDisabled
                            }"
                            class="font-weight-medium cb-font-size-5"
                          >
                            <span
                              class="cb-font-size-4"
                            >{{ index + 1 }}.</span> {{ section.name }}
                          </span>

                        </div>

                        <span
                          v-if="!section.isCompleted"
                          class="warning--text font-weight-medium cb-font-size-4 mr-2"
                        >
                          {{ `${section.completed}/${section.total}` }}
                        </span>
                      </div>
                      <template v-if="section.isDisabled" v-slot:actions>
                        <v-icon
                          color="contrast_medium"
                          size="20"
                        >
                          disabled_by_default
                        </v-icon>
                      </template>
                      <template v-else-if="sectionHasValueChanges(section)" v-slot:actions>
                        <v-icon
                          color="error"
                          size="20"
                        >
                          warning
                        </v-icon>
                      </template>
                      <template v-else-if="section.isCompleted" v-slot:actions>
                        <v-icon
                          color="success"
                          size="20"
                        >
                          check_circle
                        </v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content v-if="!section.isDisabled">
                      <div class="section-parameters">
                        <v-list class="py-0" dense>
                          <v-list-item
                            v-for="(param, paramKey, indexSubsection) in section.parameters"
                            :key="paramKey"
                            :class="{
                              'parameter-disabled': section.isDisabled,
                              'parameter-error': parameterHasValueChanges(param)
                            }"
                            class="parameter-item"
                            @click="!section.isDisabled && navigateToParameter(section.key, paramKey)"
                          >
                            <v-list-item-icon class="mr-2">
                              <v-icon
                                :color="parameterHasValueChanges(param) ? 'error' : getParameterIconColor(param.value)"
                                size="18"
                              >
                                {{ parameterHasValueChanges(param) ? 'warning' : getParameterIcon(param.value) }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="parameter-title d-flex align-center">
                                <span>{{ index + 1 }}.{{ indexSubsection + 1 }}.
                                {{ param.name || paramKey }}</span>
                                <v-chip
                                  v-if="parameterHasValueChanges(param)"
                                  class="ml-2"
                                  color="error"
                                  label
                                  text-color="white"
                                  x-small
                                >
                                  <v-icon left x-small>warning</v-icon>
                                  CAMBIO
                                </v-chip>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import checklistService from '@/services/checklistService'

  export default {
    name: 'ChecklistSectionsIndex',
    props: {
      sections: {
        type: Array,
        required: true
      },
      expandedPanels: {
        type: Array,
        default: () => []
      },
      processInfo: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        localExpandedPanels: this.expandedPanels
      }
    },
    watch: {
      expandedPanels(val) {
        this.localExpandedPanels = val
      },
      localExpandedPanels(val) {
        this.$emit('update:expandedPanels', val)
      }
    },
    methods: {
      getSectionIcon(section) {
        // Si hay cambios en los valores, mostrar el icono de warning
        if (this.sectionHasValueChanges(section)) {
          return 'warning'
        }
        return checklistService.getSectionIcon(section)
      },
      getSectionIconColor(section) {
        // Utilizar el servicio para obtener el color adecuado según el estado
        return checklistService.getSectionIconColor(
          section,
          this.sectionHasValueChanges(section),
          section.isCompleted
        )
      },
      sectionHasValueChanges(section) {
        // Verificar si la sección tiene cambios en sus valores
        return section && this.processInfo &&
          checklistService.sectionHasValueChanges(section, this.processInfo)
      },
      parameterHasValueChanges(parameter) {
        // Verificar si el parámetro tiene cambios en sus valores
        return parameter && this.processInfo &&
          checklistService.parameterHasValueChanges(parameter, this.processInfo)
      },
      getParameterIcon(value) {
        return checklistService.getParameterIcon(value)
      },
      getParameterIconColor(value) {
        return checklistService.getParameterIconColor(value)
      },
      navigateToParameter(sectionKey, paramKey) {
        // Emitir el evento con las claves de sección y parámetro
        this.$emit('scroll-to-parameter', sectionKey, paramKey)
      }
    }
  }
</script>

<style lang="scss">
  @import "@/assets/styles/resources/colors.scss";
  @import "@/assets/styles/resources/variables.scss";

  .checklist-index-scroll {
    max-height: calc(100dvh - 360px);
    @supports not (height: 100dvh) {
      max-height: calc(100vh - 380px);
    }
    overflow: auto;
  }

  .checklist-index-panels {
    .v-expansion-panel {
      margin-bottom: 0px;
      border-bottom: 1px solid $color_app_contrast_medium_low !important;
      transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);

      .v-expansion-panel-content__wrap {
        padding-left: 18px;
        transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
      }
    }

    .v-expansion-panel-header {
      min-height: 38px !important;
      padding: 0px 8px !important;
      transition: all 0.25s ease;

      .section-number-chip {
        min-width: 32px !important;
        height: 28px !important;
        font-weight: bold !important;
        margin-right: 0;
      }

      .section-title {
        font-size: 14px;
        line-height: 1.2;
        transition: color 0.25s ease;
      }
    }

    .v-expansion-panel-content {
      transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);

      .section-parameters {
        border-left: 1px solid $color_app_contrast_medium_low !important;
        transition: all 0.3s ease;

        .parameter-item {
          cursor: pointer;
          border-radius: 4px;
          transition: all 0.2s ease;
          transform: translateX(0);

          &:hover {
            background-color: rgba(0, 0, 0, 0.04);
            transform: translateX(2px);
          }

          .parameter-title {
            font-size: 13px;
            line-height: 1.3;
            transition: color 0.2s ease;
          }

          .parameter-description {
            font-size: $font-size-5;
            opacity: 0.7;
            transition: opacity 0.2s ease;
          }
        }

        // Estilo para parámetros con cambios detectados
        .parameter-error {
          border-left: 2px solid $color_app_error;
          background-color: rgba(201, 97, 106, 0.05);

          &:hover {
            background-color: rgba(201, 97, 106, 0.1);
          }
        }
      }
    }

    // Estilos para secciones deshabilitadas
    .section-disabled {
      opacity: 0.6;
      transition: opacity 0.3s ease;

    }

    .section-header-disabled {
      color: $color_app_contrast_medium !important;

      .section-title-disabled {
        color: $color_app_contrast_medium !important;
      }
    }

    .parameter-disabled {
      opacity: 0.5;
      transition: opacity 0.3s ease;
    }

    // Animación mejorada para secciones colapsadas
    .section-collapsed {
      .v-expansion-panel-content {
        max-height: 0 !important;
        opacity: 0;
        overflow: hidden;
        transform: scaleY(0.95);
        transform-origin: top;
        transition: all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1);

        .section-parameters {
          transform: translateY(-10px);
          transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1) 0.1s;
        }
      }
    }

    // Animación cuando la sección se expande
    .v-expansion-panel:not(.section-collapsed) {
      .v-expansion-panel-content {
        .section-parameters {
          transform: translateY(0);
          transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1) 0.1s;
        }
      }
    }

    // Animación adicional para el header cuando cambia de estado
    .section-header-completed {
      background: linear-gradient(90deg, rgba(76, 175, 80, 0.05) 0%, transparent 100%);
      transition: background 0.3s ease;

      &:hover {
        background: linear-gradient(90deg, rgba(76, 175, 80, 0.1) 0%, transparent 100%);
      }
    }

    // Estilos para el header cuando hay cambios en los valores (estado de error)
    .section-header-error {
      background: linear-gradient(90deg, rgba(201, 97, 106, 0.05) 0%, transparent 100%);
      transition: background 0.3s ease;

      &:hover {
        background: linear-gradient(90deg, rgba(201, 97, 106, 0.1) 0%, transparent 100%);
      }
    }

    // Efecto de pulsación suave para elementos interactivos
    .v-expansion-panel-header:active {
      transform: scale(0.98);
      transition: transform 0.1s ease;
    }
  }

  // Animación global para entrada de elementos
  @keyframes slideInFromTop {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }


</style>